import { Interval } from './PrescriptionJob';
import type { PrescriptionJob } from './PrescriptionJob';
import type Field from '../../model/Field';
import { calculateIntervalAreas } from './PrescriptionUtils';
import {
  fillNullValuesInsideField,
  isNullInterval,
  NULL_INTERVAL_VALUE,
  restoreNullValues,
} from './nullValueRegions';

export const setNullIntervalInIntervals = (intervals: Interval[], enabled: boolean): Interval[] => {
  if (enabled === intervals.some(isNullInterval)) return intervals;
  return enabled
    ? [
        new Interval(NULL_INTERVAL_VALUE, NULL_INTERVAL_VALUE, intervals[0].prescription),
        ...intervals,
      ]
    : intervals.filter((interval) => !isNullInterval(interval));
};

export const setNullIntervalForJob = (
  job: PrescriptionJob,
  field: Field,
  enabled: boolean
): PrescriptionJob => {
  if (enabled === job.intervals.some(isNullInterval)) return job;

  const nextJob = {
    ...job,
    values: enabled
      ? fillNullValuesInsideField(job.values, job.bounds, field.polygon.coordinates)
      : restoreNullValues(job.values),
    intervals: setNullIntervalInIntervals(job.intervals, enabled),
  };

  return calculateIntervalAreas(nextJob);
};
